function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  d: "M7 15A7 7 0 107 1a7 7 0 000 14z",
  stroke: "currentColor",
  strokeWidth: 2
});

var SvgCircleCheck2 = function SvgCircleCheck2(props) {
  return React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml,%3Csvg width='15' height='16' viewBox='0 0 15 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M7 15C10.866 15 14 11.866 14 8C14 4.13401 10.866 1 7 1C3.13401 1 0 4.13401 0 8C0 11.866 3.13401 15 7 15Z' stroke='currentColor' stroke-width='2' /%3E %3C/svg%3E";
export { SvgCircleCheck2 as ReactComponent };